import Vue from "vue"
import Router from "vue-router"

// Get all routes from modules and flatten that array of routes
const routes = () => {
  const req = require.context("@/Modules/", true, /Routes\/index\.(ts|js)$/i)
  return req.keys().flatMap((key) => {
    return req(key).default
  })
}

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/calendar" // Default view
    },
    ...routes()
  ]
})
